export default {"src":"/_next/static/media/living-room.mono.d31d6901.svg","height":262,"width":364,"blurWidth":0,"blurHeight":0};